let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6gxg1")).then(() => parcelRequire('8IvqN'));